export enum SubTitleSeparatorEnum {
  default = ':',
  empty = '',
  space = '',
};
